export default "__VITE_ASSET__DqybYm4k__"